// "regular" is a navigation/select value, never a ministry identifier.
export function ministryIdForApi(value?: string | null): string | undefined {
  return value === "regular" || !value ? undefined : value;
}
